"use strict"

import axios from 'axios';
import { Message } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/auth';
import { MessageBox } from 'element-ui';
import { tirm } from '@/utils/object';


// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 72000000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.token) {
        config.headers['X-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    var param = tirm(config.data);
    config.data= param;
    config.headers['Content-Type'] = 'application/json;charset=UTF-8' // application/json /application/x-www-form-urlencoded;charset=UTF-8
    // config['data1']= param;
    // console.log('请求参数：',config);
    return config;
}, error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * code大于0抛错
         */
        const res = response.data;
        const payload = res.payload
        if(payload.resultStatus&&payload.resultStatus.status>0){
            // console.log(res.payload.resultStatus.status)
            // 130033:非法的token; 130033:其他客户端登录了;  130033:Token 过期了;
            if (res.payload.resultStatus.status === 130033) {
                MessageBox.alert('你已被登出，请重新登录，如非本人操作请修改密码', '提示', {
                    confirmButtonText: '重新登录',
                    callback: action => {
                        store.dispatch('FedLogOut').then(() => {
                            location.reload();// 为了重新实例化vue-router对象 避免bug
                        });
                    }
                });
            }else{

                Message({
                    message: payload.resultStatus.message,
                    type: 'error',
                    duration: 5 * 1000
                });
            }
            return Promise.reject('error');
        }else{
            return Promise.resolve(response.data.payload);
        }

    },
    error => {
        console.log('err:',error);// for debug
        var message='';
        if(error.message==='Network Error'){
            message = '网络异常';
        }else if(error.message==='timeout of 200000ms exceeded'){
            message = '请求服务器超时，请重试';
        }else{
            message =  error.message;
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        });
        // var message = '网络异常'
        // if(error==='Error: Network Error'){
        //     message = '网络异常'
        // }
        return Promise.reject(error);
    }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js